import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ElementIconType, ElementType, ToolboxTypeElement } from 'src/app/_core/models/ToolboxModel';
import { ToolboxItemType } from '../../../_core/models/ToolboxModel';
import { IPointer } from 'src/app/_core/interfaces/IPointer';
import { SvgAreaBaseComponent } from '../svg-area-base/svg-area-base.component';
import { FrontProfile } from 'src/app/_core/models/profiles/front.model';
import { Tags } from 'src/app/_core/constants/constants';
import { AreaType } from 'src/app/_core/interfaces/IAreaType';

@Component({
	selector: 'g[app-svg-side]',
	templateUrl: './svg-side.component.html',
	styleUrls: ['./svg-side.component.css']
})
export class SvgSideComponent extends SvgAreaBaseComponent {
	private _elements: any[];

	@Input() set elements(p: any[]) {
		this._elements = p;
	}
	get elements() {
		return this._elements;
	}
	@Output() openLayoutEvent = new EventEmitter<boolean>(false);

	onSideDrop(pointerEvent: IPointer) {
		var addElements = this.toolboxService.iconClass(ElementType.Shape, this.areaService.areaType) == ElementIconType.AddElements;
		if (this.currentTool == null && !addElements) {
			return;
		}

		if ((addElements || ToolboxTypeElement.get(this.currentTool.type) != null) && this.projectService.profileService.getVerticals(this.areaService.areaType).length == 0) {
			this.openLayoutEvent.emit(true);
			return;
		}

		switch (this.currentTool.type) {
			case ToolboxItemType.GlassWall:
				this.projectService.createGlassWall(pointerEvent, this.currentTool);
				break;
			default:
				this.areaService.onDrop(pointerEvent, this.currentTool);
				break;
		}

		this.toolboxService.setCurrTool(null);
		this.projectService.recalculateDimensions();
		this.projectService.emitChange();
	}

	get fronts() {
		var t = this.areaService.areaType == AreaType.Left ? Tags.LEFT_FRONT_TAG : Tags.RIGHT_FRONT_TAG;
		var f = this.elements['Front'].filter((f:FrontProfile) => f.tag == t);
		if (f.length == 0) {
			f = this.elements['Front'].filter((f:FrontProfile) => f.tag == Tags.ANY_FRONT_TAG);
		}
		return f;
	}

}
